"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _withTheme = require("../../wrappers/with-theme");

var _Item = _interopRequireDefault(require("./Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MobileMenu = function MobileMenu(_ref) {
  var open = _ref.open,
      toggle = _ref.toggle,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
      _ref$rightMenu = _ref.rightMenu,
      rightMenu = _ref$rightMenu === void 0 ? null : _ref$rightMenu;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(open ? "md:hidden" : "hidden", " ").concat(theme.topnavMobileContainer),
    id: "mobile-menu"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: i,
      type: "top",
      to: page.path,
      icon: page.icon,
      subMenus: (0, _lodash["default"])(page, "subMenus", [])
    }, page.name);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, rightMenu));
};

var DesktopMenu = function DesktopMenu(_ref2) {
  var open = _ref2.open,
      toggle = _ref2.toggle,
      _ref2$menuItems = _ref2.menuItems,
      menuItems = _ref2$menuItems === void 0 ? [] : _ref2$menuItems,
      _ref2$rightMenu = _ref2.rightMenu,
      rightMenu = _ref2$rightMenu === void 0 ? null : _ref2$rightMenu,
      _ref2$leftMenu = _ref2.leftMenu,
      leftMenu = _ref2$leftMenu === void 0 ? null : _ref2$leftMenu;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.topnavWrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.topnavContent, " justify-between")
  }, /*#__PURE__*/_react["default"].createElement("div", null, leftMenu), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.topnavMenu)
  }, menuItems.map(function (page, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: i,
      type: "top",
      to: page.path,
      icon: page.icon,
      subMenus: (0, _lodash["default"])(page, "subMenus", [])
    }, page.name);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.topmenuRightNavContainer)
  }, rightMenu), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: theme.mobileButton,
    onClick: function onClick() {
      return toggle(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Open main menu"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center items-center text-2xl"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: !open ? theme.menuOpenIcon : theme.menuCloseIcon
  }))))));
};

var TopNav = function TopNav(_ref3) {
  var props = _extends({}, _ref3);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("nav", null, /*#__PURE__*/_react["default"].createElement(DesktopMenu, _extends({
    open: open,
    toggle: setOpen
  }, props)), /*#__PURE__*/_react["default"].createElement(MobileMenu, _extends({
    open: open
  }, props)));
};

var _default = TopNav;
exports["default"] = _default;